import * as S from "./TypingIndicator.styled";

export const TypingIndicator = () => {
  return (
    <S.Indicator>
      <span></span>
      <span></span>
      <span></span>
    </S.Indicator>
  );
};
